import PropTypes from 'prop-types';

export const assignmentGradesType = PropTypes.objectOf(
  PropTypes.shape({
    assignmentId: PropTypes.string.isRequired,
    displayGrade: PropTypes.string,
    hasSubmission: PropTypes.bool.isRequired,
    lateSubmission: PropTypes.bool.isRequired,
    isAwaitingDecision: PropTypes.bool,
  })
);

export const studentGradesType = PropTypes.shape({
  studentId: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  avatar: PropTypes.string,
  displayGrade: PropTypes.string,
  assignmentGrades: assignmentGradesType,
});
